// import React, { useEffect, useState } from "react";
// import SliderImage1 from '../Assets/SliderImage1.png';
// import { Get_Api } from "../ApiUrls";

// const AllDeveloper = () => {
//   const [Alldevelopers, setAlldevelopers] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [itemsPerPage, setItemsPerPage] = useState(getItemsPerPage());
//   const [isHovered, setIsHovered] = useState(false); // For pausing on hover

//   const GetAlldevelopers = async () => {
//     try {
//       const response = await Get_Api("api/admin/GetDeveloperList");
//       setAlldevelopers(response?.data || []);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     GetAlldevelopers();
//   }, []);

//   function getItemsPerPage() {
//     if (window.innerWidth <= 600) return 1; // Mobile
//     if (window.innerWidth <= 900) return 2; // Tablet
//     return 3; // Desktop
//   }

//   const handleResize = () => {
//     setItemsPerPage(getItemsPerPage());
//   };

//   useEffect(() => {
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const nextSlide = () => {
//     setCurrentIndex((prev) => (prev + 1) % Alldevelopers.length);
//   };

//   const prevSlide = () => {
//     setCurrentIndex((prev) => (prev - 1 + Alldevelopers.length) % Alldevelopers.length);
//   };

//   useEffect(() => {
//     if (Alldevelopers.length === 0) return; 

//     const interval = setInterval(() => {
//       if (!isHovered) {
//         nextSlide();
//       }
//     }, 3000); 

//     return () => clearInterval(interval);
//   }, [currentIndex, isHovered, Alldevelopers.length]);

//   return (
//     <div
//       className="developer-slider"
//       onMouseEnter={() => setIsHovered(true)} 
//       onMouseLeave={() => setIsHovered(false)} 
//     >
//       <h2 className="gallery-title">DEVELOPERS GALLERY</h2>
//       <div className="slider-container2">
//         <button className="nav-button left" onClick={prevSlide}>
//           &#10094;
//         </button>
//         <div className="slider">
//           {Alldevelopers?.slice(currentIndex, currentIndex + itemsPerPage)?.map((dev) => (
//             <div key={dev?._id} className="slideingimgge">
//               <img src={dev?.Image || SliderImage1} alt={dev?.Name} />
//             </div>
//           ))}
//         </div>
//         <button className="nav-button right" onClick={nextSlide}>
//           &#10095;
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AllDeveloper;

import React, { useEffect, useState } from "react";
import SliderImage1 from '../Assets/SliderImage1.png';
import { Get_Api } from "../ApiUrls";

const AllDeveloper = () => {
  const [Alldevelopers, setAlldevelopers] = useState([]);

  const GetAlldevelopers = async () => {
    try {
      const response = await Get_Api("api/admin/GetDeveloperList");
      setAlldevelopers(response?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetAlldevelopers();
  }, []);

  return (
    <div className="all-dev-slider">
      <h2 className="all-dev-gallery-title">DEVELOPERS GALLERY</h2>
      <div className="all-dev-slider-container">
        <div className="all-dev-slider-track">
          {[...Alldevelopers, ...Alldevelopers].map((dev, index) => (
            <div key={index} className="all-dev-slide">
              <img src={dev?.Image || SliderImage1} alt={dev?.Name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AllDeveloper;
